<div class="users-container" style="width: 100%; display: flex; flex-direction: column;">
  
  <!-- Add User Button: hidden on handset -->
  <div *ngIf="!(isHandset$ | async)" style="display: flex; align-items: center; gap: 20px; margin-bottom: 10px;">
    <button *ngIf="currentUserIsAdmin" mat-raised-button color="primary" (click)="addUser()">Add User</button>
  </div>

  <!-- List of Users -->
  <div class="table-scroll">
    <table mat-table [dataSource]="filteredUsers" class="mat-elevation-z8" style="width: 100%;">
      <!-- Username Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let user">{{ user.firstName }} {{ user.lastName }}</td>
      </ng-container>

      <!-- Nickname Column -->
      <ng-container matColumnDef="nickname">
        <th mat-header-cell *matHeaderCellDef>Nickname</th>
        <td mat-cell *matCellDef="let user">{{ user.nickname }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <!-- Role Column -->
      <ng-container matColumnDef="administrator">
        <th mat-header-cell *matHeaderCellDef>Administrator</th>
        <td mat-cell *matCellDef="let user">{{ user.isAdministrator }}</td>
      </ng-container>

      <!-- Role Column -->
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Active</th>
        <td mat-cell *matCellDef="let user">{{ user.isActive }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let user">
          <button mat-button color="primary" (click)="editUser(user)">Edit</button>
          <button mat-button color="warn" (click)="deleteUser(user.id)">Delete</button>
        </td>
      </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
